import { AttachmentProps } from './attachment'

export interface ResourceProps {
    _id: string
    id?: string
    title: string
    folders?: ResourceProps[]
    countSubFolders?: number
    resources?: ResourceProps[]
    resourceCount?: number
    resourceType?: ResourceType
    folderType?: FolderType
    parentFolder?: ResourceProps
    parentFolderId?: string
    referenceFolder?: ResourceProps
    referenceSubfolder?: ResourceProps
    creatorUserInfo?: CreatorUserInfo
    likes?: number
    isLiked?: boolean
    isFavourite?: boolean
    status?: string
    views?: number
    createdOn?: string
    department?: string
    description?: string
    isSelected?: boolean
    attachments?: Attachment[]
    survey?: SurveyProps
    abstract?: any
    chapters?: Chapter[]
    storeList?: string[]
    visibility?: Visibility[]
    recipients?: string[]
    lastUpdateDate?: string
    visualizations?: number
    sendMailUserInfo?: any
    requiredConfirmReading?: boolean
    enableCommentsAndReactions?: boolean
    bannerList?: string[]
    countryList?: string[]
    regionList?: string[]
    onClick?: () => void
}

export enum ResourceType {
    folder = 'folder',
    subfolder = 'sub-folder',
    file = 'file',
    article = 'article',
    form = 'form',
    document = 'document'
}

export enum FolderType {
    document = 'document',
    form = 'form',
    favourites = 'favourites',
}

export interface FiltersProps {
    page: number
    page_size: number
    first: number
    rows: number
    sortingType: SortingType
}

export enum SortingType {
    alphabetical = 'alphabetical',
    lastUpdated = 'lastUpdated',
    mostViewed = 'mostViewed',
    highestRating = 'highestRating',
}

export interface CreatorUserInfo {
    name: string
    lastname: string
    nickname?: string
    userId: string
    role: string
    date: number
}

export interface Attachment {
    file?: File
    _id: string
    url: string
    ext: string
    name: string
}

export interface Chapter {
    text: any
    index: number
    title: string
    attachments: AttachmentProps[]
    isEdit?: boolean
    isDone?: boolean
}

export interface ReadFolderQuery {
    folderType: FolderType
    sortingType: SortingType
    folderId?: string
}

export interface SidebarAccordionProps {
    title: string
    resources: ResourceProps[]
    open?: boolean
}

export interface AccordionTabProps {
    title: string
    content: any
    disabled: boolean
    onOpen?: () => void
    id?: string
}

export interface DistributionListProps {
    listName: {
        value: string
    }
    selectedStoreList: {
        value: any[]
        mandatory: boolean
    }
    selectedDistributionList: {
        value: any[]
    }
}

export interface FormProps {
    banner?: string
    country?: string
    region?: string
    surveyId?: string
    surveyName?: string
    surveyType?: string
    surveyUrl?: string
    validFrom?: string
    validTo?: string
    disabled?: boolean
}

export interface SurveyProps {
    surveyId?: string
    surveyUrl?: string
    surveyName?: string
    startDate?: number
    endDate?: number
    priority?: 'standard' | 'urgent'
}

export enum Visibility {
    gatekeeper = 'gatekeeper',
    gatekeeperadmin = 'gatekeeperadmin',
    creator = 'creator',
    regionalmanager = 'regionalmanager',
    storemanager = 'storemanager',
    storeassociate = 'storeassociate',
    optemployeed = 'optemployeed',
    optindependent = 'optindependent',
    picturemanager = 'picturemanager',
    picturemanageradmin = 'picturemanageradmin',
    virtualstore = 'virtualstore',
}

export interface TreeFolderProps extends ResourceProps {
    data: any
    key: string
    icon: string
    label: string
    selected: boolean
    expanded: boolean
    selectable: boolean
    expandable: boolean
    folderType: FolderType
    resourceType: ResourceType
    children: TreeFolderProps[]
    leaf?: boolean
}
